






































import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
    components: {},
})
export default class CommunitySettingHeader extends Vue {
    private community: any;
    private communityId = this.$route.params.community_id;
    created() {
        // this.community = this.$api.getCommunityInfo(this.communityId);
    }
}
